import * as React from 'react';
import { ChevronDown } from '@wix/wix-ui-icons-common/on-stage';
import { TextButton, TextButtonPriority } from '../TextButton';
import { DATA_HOOKS } from './constants';
import { FloatingDropdownOptionProps } from './FloatingDropdownOption';
import { st, classes } from './FloatingDropdownBase.st.css';
import classnames from 'classnames';
import { FloatingDropdownBaseProps } from './types';

export class FloatingDropdownBase extends React.Component<FloatingDropdownBaseProps> {
  _getSelectedOption = (selectedId: string) => {
    const { options } = this.props;
    return options.find(({ id }) => selectedId === id);
  };

  _onSelect = (e) => {
    const { onChange } = this.props;
    const selectedId = e.target.value;

    if (onChange) {
      onChange(selectedId);
    }
  };

  _getContent() {
    const {
      value,
      placeholder,
      label,
      options,
      'aria-label': ariaLabel,
      'aria-labelledby': ariaLabelledBy,
      mobile,
      disabled,
      name,
    } = this.props;

    const selectedOption = this._getSelectedOption(value);

    return (
      <>
        <div className={classes.content}>
          <div className={classes.textContent}>
            <span className={classes.label}>{label}</span>
            <div
              className={classes.selectedValue}
              data-hook={DATA_HOOKS.baseSelectedValue}
            >
              {selectedOption?.value || placeholder}
            </div>
          </div>
          <ChevronDown aria-hidden className={classes.arrowIcon} />
        </div>
        {mobile ? (
          <select
            value={value}
            name={name}
            className={classes.select}
            aria-label={ariaLabel}
            aria-labelledby={ariaLabelledBy}
            data-hook={DATA_HOOKS.nativeSelect}
            onChange={this._onSelect}
            disabled={disabled}
          >
            {placeholder ? (
              <option value="" disabled>
                {placeholder}
              </option>
            ) : null}
            {options.map((option: FloatingDropdownOptionProps) =>
              !option.divider ? (
                <option
                  value={option.id}
                  disabled={!option.isSelectable}
                  key={option.id}
                >
                  {option.value}
                </option>
              ) : null,
            )}
          </select>
        ) : null}
      </>
    );
  }

  render() {
    const {
      'aria-label': ariaLabel,
      'aria-labelledby': ariaLabelledBy,
      'aria-activedescendant': ariaActivedescendant,
      'aria-controls': ariaControls,
      mobile,
      id,
      disabled,
      className,
      displayBlock,
    } = this.props;

    let content = this._getContent();

    if (!mobile) {
      content = (
        <TextButton
          aria-haspopup="true"
          aria-expanded={this.props.isExpanded}
          aria-label={ariaLabel}
          aria-labelledby={ariaLabelledBy || id}
          aria-activedescendant={ariaActivedescendant}
          disabled={disabled}
          data-hook={DATA_HOOKS.floatingDropdownButton}
          priority={TextButtonPriority.secondary}
          className={classes.btn}
          aria-controls={ariaControls}
        >
          {content}
        </TextButton>
      );
    }

    return (
      <div
        className={st(
          classes.root,
          { mobile, disabled },
          classnames(classes.overrideStyleParams, className, {
            [classes.displayBlock]: displayBlock,
          }),
        )}
        data-hook={DATA_HOOKS.base}
      >
        {content}
      </div>
    );
  }
}
